module.exports = __webpack_public_path__ + "assets/img/about-us.2454d55a.webp";